import ModalConfirm from "../../player/modal";
import styles from "./index.module.less";
import { ButtonField } from "@wk/components-react16";
import ImageCropper from "../imageCropper";
import { useState, useRef, forwardRef, useImperativeHandle } from "react";

const ChangeHeaderPic = forwardRef(
  (
    {
      isCropPicModalOpen,
      setIsCropPicModalOpen,
      changeUserHeaderPic,
      messageOpen,
    },
    ref
  ) => {
    const imageCropperRef = useRef(null);
    const headerPicSelect = (e) => {
      setTimeout(() => {
        imageCropperRef.current.handleFileSelect(e);
      });
    };

    // 暴露方法给父组件
    useImperativeHandle(ref, () => ({
      headerPicSelect,
    }));

    return (
      <ModalConfirm
        height="auto"
        isOpen={isCropPicModalOpen}
        onClose={() => {
          setIsCropPicModalOpen(false);
        }}
        children={
          <div className={styles["crop-pic-modal"]}>
            <ImageCropper
              ref={imageCropperRef}
              changeUserHeaderPic={changeUserHeaderPic}
              setIsCropPicModalOpen={setIsCropPicModalOpen}
              messageOpen={messageOpen}
            />
          </div>
        }
        title={"头像"}
        onConfirm={() => {
          console.log("1111");
        }}
        // isConfirmLoading={}
        okText="确定"
        isFooter={false}
      />
    );
  }
);

export default ChangeHeaderPic;
